
import { Component, Mixins } from "vue-property-decorator";
import { default as TextDrawableObjectDrawerBase } from "./TextDrawableObjectDrawerBase.vue";

@Component
export default class StandardTextDrawableObjectDrawerBase extends Mixins(TextDrawableObjectDrawerBase) {
}
